// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logoImage":"Header_logoImage__OY9g1"};